import { Component } from 'react';
import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NSButtonBlue, NSColumn, NSLabel } from 'namirasoft-site-react';
import { PasswordRouterProps } from '../PasswordRouterProps';

export interface QuestionsSummaryProps extends NSARouterMakerResult, PasswordRouterProps
{
    questions: string[];
    answers: string[];
    submitTitle?: string;
    loadUser: () => Promise<void>;
}

export class QuestionsSummary extends Component<QuestionsSummaryProps>
{
    override render()
    {
        return (
            <NSColumn style={{ padding: "0 0.5rem", alignItems: "flex-start" }}>
                <NSLabel
                    title="Setup is successfuly done."
                    description="Please print your questions/answers list and keep it somewhere safe."
                    style={{ padding: "0 0 1rem" }}
                />
                {
                    this.props.questions.map((question, index) => (
                        <NSLabel
                            key={index + 1}
                            title={`${index + 1}. ${question}`}
                            description={this.props.answers[index]}
                            style={{ padding: "0" }}
                        />
                    ))
                }
                <NSButtonBlue
                    title="Print Information"
                    onClick={{
                        showLoading: false,
                        action: (onFinished) =>
                        {
                            try
                            {
                                window.print();
                            }
                            catch (error)
                            {
                                this.props.notifier.onError(error as Error);
                            }
                            onFinished();
                        }
                    }}
                    classList={["d-print-none mx-auto"]}
                />
                <NSButtonBlue
                    title={this.props.submitTitle ?? "Start Using Namirasoft Password"}
                    onClick={{
                        showLoading: true,
                        action: async (onFinished) =>
                        {
                            try
                            {
                                await this.props.loadUser();
                            }
                            catch (error)
                            {
                                this.props.notifier.onError(error as Error);
                            }
                            onFinished();
                        }
                    }}
                    classList={["d-print-none mx-auto"]}
                />
            </NSColumn>
        )
    }
}

export default QuestionsSummary